type AnswerOfFieldType<T extends ScreenerFieldType> = {
  [key in T]: ScreenerResponseAnswer<key>;
}[T];

export const isAnswerOfFieldType = <T extends ScreenerFieldType>(
  answer: ScreenerResponseAnswer,
  field_type: T
): answer is AnswerOfFieldType<T> => answer.field_type === field_type;
